// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__gubnP","info":"PatientInfo_info__3QPDp"};